<template>
  <div class="modal-room-details">
    <a-card class="l-container mt-4 mb-4">
      <a-button @click="visible = true"  preset="card"> Start Me up </a-button>
    </a-card>

    <!-- Modal -->
    <Modal :visible="visible" size="large" @ok="visible = false" @cancel="visible = false" class="h-5/6">
      <div class="room-detail">
        <!-- Header -->
        <div class="room-header">
          <div class="title-modal">
            <span>お部屋の詳細</span>
          </div>
        </div>

        <!-- Card-content -->
        <div class="room-detail-wrap">
          <!-- Left-content -->
          <div class="room-detail-left">
            <div class="header">
              <Tag type="primary" outline size="small" :text="tag" v-for="(tag, idx) in tags" :key="idx" />
            </div>

            <div class="title">
              <span>スーペリアナチュラルツイン</span>
            </div>

            <div class="content">
              <!-- Hotel-descriptions -->
              <div class="hotel-meta-wrap">
                <div class="hotel-meta">
                  <div class="meta-item" v-for="(description, idx) in hotelDescription" :key="idx" >
                    <i class="icon" :class="description.icon" />
                    <span>{{ description.data }}</span>
                  </div>
                </div>
              </div>

              <!-- Silde-images-mobile -->
              <div class="slide-images-mobile">
                <img
                  v-for="(slide, idx) in slides"
                  :key="idx"
                  :src="slide.img"
                  :alt="slide.alt"
                />
              </div>

              <!-- Hotel-detail -->
              <div class="text-data">
                <p v-for="(text, idx) in textData" :key="idx">{{ text }}</p>
              </div>
            </div>
          </div>

          <!-- Right-content -->
          <div class="room-detail-right">
            <CarouselThumbnail :showLabel="true" />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Modal, Tag } from '@/components/primitive'
import { CarouselThumbnail } from '@/components/compound'

export default {
  name: 'PopUpRoomDetails',
  components: {
    CarouselThumbnail,
    Modal,
    Tag
  },
  data() {
    return {
      visible: false,
      tags: ['バス', 'トイレ', '部屋でインターネット接続可能'],
      slides: [
        { imageUrl: require('@/assets/images/base.png'), alt: 'base' },
        { imageUrl: require('@/assets/images/base.png'), alt: 'base' },
        { imageUrl: require('@/assets/images/base.png'), alt: 'base' },
        { imageUrl: require('@/assets/images/base.png'), alt: 'base' }
      ],
      hotelDescription: [
        { icon: 'icon-bor-people', data: '定員 2名' },
        { icon: 'icon-bor-bed', data: 'キングベッド 1台' },
        { icon: 'icon-bor-m2', data: '部屋のサイズ 47.5㎡' },
        { icon: 'icon-bor-no-smoking', data: '禁煙' }
      ],
      textData: [
        '幅123cmのセミダブルベッドを採用したお部屋です。',
        '窓際にはゆっくりとお寛ぎいただけるL型のソファスペースを確保しております。ファミリーやカップルに人気のツインルームです。'
      ]
    }
  },
  setup() {
    return {
      showModal: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
